import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Coated Paper Bags - INGAZ Print";

function CoatedPaperBags() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Coated Paper Bags" images={[asset('assets/coated_bag_front_1770924633258.png'), asset('assets/coated_bag_side_1770924650751.png'), asset('assets/coated_bag_angle_1770924667012.png'), asset('assets/image20.webp')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Coated Paper Bags" data-ar="أكياس ورق مطلي">Coated Paper Bags</h1>
                <p className="product-description" data-en="Premium coated paper bags for luxury retail, boutiques, and events." data-ar="أكياس ورق مطلي فاخرة للبيع بالتجزئة الفاخر والمحلات والفعاليات.">Premium coated paper bags for
                  luxury retail, boutiques, and events.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Premium Quality" data-ar="جودة عالية">Premium Quality</div>
                      <div className="feature-detail" data-en="Luxurious finish" data-ar="لمسة نهائية فاخرة">Luxurious finish
                      </div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/printing.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Full Color Printing" data-ar="طباعة ملونة كاملة">Full Color Printing
                      </div>
                      <div className="feature-detail" data-en="Vibrant designs" data-ar="تصاميم نابضة بالحياة">Vibrant designs
                      </div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="High-gloss or matte coating for premium appearance" data-ar="طلاء لامع أو غير لامع للحصول على مظهر راقي">
                      High-gloss or matte coating for premium appearance</li>
                    <li data-en="Excellent printing quality for brand visibility" data-ar="جودة طباعة ممتازة لرؤية العلامة التجارية">
                      Excellent printing quality for brand visibility</li>
                    <li data-en="Strong and durable with reinforced handles" data-ar="قوي ومتين مع مقابض معززة">
                      Strong and durable with reinforced handles</li>
                    <li data-en="Perfect for high-end retail and gift packaging" data-ar="مثالي للبيع بالتجزئة الفاخر وتغليف الهدايا">
                      Perfect for high-end retail and gift packaging</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Luxury Boutiques" data-ar="محلات فاخرة">Luxury Boutiques</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Premium Gifts" data-ar="هدايا فاخرة">Premium Gifts</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Events & Expos" data-ar="الفعاليات والمعارض">Events &amp; Expos</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Brand Promotion" data-ar="الترويج للعلامة التجارية">Brand Promotion
                      </div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Coated Paper Bags" data-ar="قم بتكوين أكياس ورق مطلي">Configure Your Coated Paper
                  Bags</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="Medium" data-dims="25x32x10cm">
                      <span data-en="Medium" data-ar="متوسط">Medium</span><br /><span>25x32x10cm</span>
                    </div>
                    <div className="size-option" data-size="Large" data-dims="32x40x12cm"><span data-en="Large" data-ar="كبير">Large</span><br /><span>32x40x12cm</span>
                    </div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="Custom" data-ar="مخصص">Custom</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="coated-150" data-en="Coated Art Paper 150 gsm" data-ar="ورق آرت مطلي 150 جم">
                        Coated Art Paper 150 gsm
                      </option>
                      <option value="coated-200" data-en="Coated Art Paper 200 gsm" data-ar="ورق آرت مطلي 200 جم">Coated Art
                        Paper 200 gsm</option>
                      <option value="coated-250" data-en="Coated Art Paper 250 gsm" data-ar="ورق آرت مطلي 250 جم">Coated Art
                        Paper 250 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printed Sides" data-ar="الجوانب المطبوعة">Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="Single Side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Single Side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double Sides" data-ar="جانبان">
                      <div style={{display: 'flex', gap: 6}}>
                        <img src={asset('assets/paperside.svg')} alt="" />
                        <img src={asset('assets/paperside.svg')} alt="" />
                      </div>
                      <span>Double Sides</span>
                    </div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Matt Cellophane" data-ar="سيلوفان غير لامع">Matt Cellophane</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Gloss Cellophane" data-ar="سيلوفان لامع">Gloss Cellophane</span>
                    </label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                <NotesField />
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload Design Files" data-ar="رفع ملفات التصميم">Upload Design Files</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize" data-en="Medium 25x32x10cm" data-ar="متوسط 25x32x10 سم">Medium 25x32x10cm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper" data-en="Coated Art Paper 150 gsm" data-ar="ورق فني مطلي 150 جرام">Coated Art Paper 150 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Color:" data-ar="اللون:">Color:</span>
                    <span className="summary-value" id="summaryColor" data-en="Colored" data-ar="ملون">Colored</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Sides:" data-ar="الجوانب:">Sides:</span>
                    <span className="summary-value" id="summarySides" data-en="Single Side" data-ar="وجه واحد">Single Side</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Lamination:" data-ar="التغليف:">Lamination:</span>
                    <span className="summary-value" id="summaryLamination" data-en="None" data-ar="لا شيء">None</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design
                    review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default CoatedPaperBags;
